module.exports = __webpack_public_path__ + "09e7a17dd4168192761f4cd06b5cbe9c.png";